import { combineReducers } from "redux";

import themeReducer from "./themeReducers";

export default combineReducers({
	themeReducer,
});
